import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";

const ViewBusiness = ({
  display,
  setSelectedBusiness,
  tableDisplay,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  refresh,
  setRefresh,
}) => {
  const [linkedUser, setLinkedUser] = useState(null);
  const [linkedUserData, setLinkedUserData] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [email, setEmail] = useState("");
  const AnswerRequest = async (answer) => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/thirdParty/changeBusinessStatus",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            businessId: display.id,
            answer: answer,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setSelectedBusiness(null);
        setRefresh(refresh ? false : true);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage("Could not create yur share account please contact support");
        setLoading(false);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage("Could not create yur share account please contact support");
      setLoading(false);
    }
  };
  const GetLinkedUser = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/thirdParty/getUserLink",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: display.userId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.business) {
        setLoading(false);

        setLinkedUserData(respnseData.business);
        setFirstName(respnseData.business.firstName);
        setLastName(respnseData.business.lastName);
        setCellNumber(respnseData.business.cellNumber);
        setEmail(respnseData.business.email);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage("Could not find linked user contact support");
        setLoading(false);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage("Please check your network connection");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (display) {
      GetLinkedUser();
    }
  }, [display]);
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: colors.white,
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.3s",
      }}
    >
      <div style={{ position: "absolute", left: 20, top: 20 }}>
        <BaseButtons
          label={"BACK"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          onClick={() => setSelectedBusiness(null)}
          width={100}
        />
      </div>
      {tableDisplay === "requests" ? (
        <div
          style={{ position: "absolute", right: 20, top: 20, display: "flex" }}
        >
          <BaseButtons
            label={"APPROVE"}
            backgroundColor={colors.greenLight}
            borderRadius={8}
            onClick={() => AnswerRequest("APPROVED")}
            width={100}
          />
          <div style={{ width: 20 }} />
          <BaseButtons
            label={"DECLINE"}
            backgroundColor={colors.orangeDark}
            borderRadius={8}
            onClick={() => AnswerRequest("DECLINED")}
            width={100}
          />
        </div>
      ) : null}
      <div
        style={{
          flex: 0.5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextInputField
          labelTitle={"BUSINESS NAME"}
          mini={true}
          readOnly={true}
          value={display ? display.businessName : "loading"}
        />
        <TextInputField
          labelTitle={"SERVICE"}
          mini={true}
          readOnly={true}
          value={display ? display.service : "loading"}
        />
        <div style={{ width: 250, marginTop: 20 }}>
          <CheckInput
            label={"CALLOUTS"}
            selected={
              display ? (display.callOut === "YES" ? true : false) : false
            }
          />
        </div>
        <TextInputField
          labelTitle={"CELL NUMBER"}
          mini={true}
          readOnly={true}
          value={display ? display.cellNumber : "loading"}
        />
        <TextInputField
          labelTitle={"LANDLINE"}
          mini={true}
          readOnly={true}
          value={display ? display.landline : "loading"}
        />
        <TextInputField
          labelTitle={"EMAIL"}
          mini={true}
          readOnly={true}
          value={display ? display.email : "loading"}
        />
      </div>
      <div>
        <TextInputField
          labelTitle={"WEBSITE ADDRESS"}
          mini={true}
          readOnly={true}
          value={display ? display.website : "loading"}
        />
        <TextInputField
          labelTitle={"STATUS"}
          mini={true}
          readOnly={true}
          value={display ? display.status : "loading"}
        />
        <TextInputFieldArea
          labelTitle={"ABOUT US"}
          mini={true}
          readOnly={true}
          value={display ? display.aboutUs : "loading"}
          height={170}
        />
        <div style={{ height: 20 }} />
        <BaseButtons
          label={"LINKED USER"}
          width={250}
          borderRadius={8}
          backgroundColor={colors.greenDark}
          onClick={() => setLinkedUser(true)}
        />
      </div>
      <div
        style={{
          overflow: "hidden",
          position: "absolute",
          width: linkedUser ? "50%" : 0,
          height: "100%",
          right: 0,
          backgroundColor: colors.greenLight,
          transition: "width 0.3s",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: 30,
              marginBottom: 30,
              fontWeight: "bold",
              color: colors.white,
            }}
          >
            LINKED USER
          </div>
          <TextInputField
            mini={true}
            labelTitle={"FIRST NAME"}
            readOnly={true}
            value={firstName}
            invert={true}
            width={"100%"}
            size={"70%"}
          />
          <TextInputField
            mini={true}
            labelTitle={"LAST NAME"}
            readOnly={true}
            value={lastName}
            invert={true}
            width={"100%"}
            size={"70%"}
          />
          <TextInputField
            mini={true}
            labelTitle={"EMAIL"}
            readOnly={true}
            value={email}
            invert={true}
            width={"100%"}
            size={"70%"}
          />
          <TextInputField
            mini={true}
            labelTitle={"CELL NUMBER"}
            readOnly={true}
            value={cellNumber}
            invert={true}
            width={"100%"}
            size={"70%"}
          />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <BaseButtons
            label={"CLOSE"}
            width={"80%"}
            backgroundColor={colors.orangeDark}
            borderRadius={8}
            onClick={() => setLinkedUser(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewBusiness;
